import VueRouter, { RouteConfig } from 'vue-router';
import { withPrefix } from '.';

export default (router: VueRouter): RouteConfig[] => {
  return withPrefix('/oversight', [
    {
      path: '',
      name: 'oversight',
      redirect: { name: 'oversight-list' },
    },
    {
      path: '/list',
      name: 'oversight-list',
      component: () => import('@/views/oversight/OversightInstanceList.vue'),
    },
    {
      path: '/create',
      name: 'oversight-create',
      component: () => import('@/views/oversight/OversightInstanceCreate.vue'),
    },
    {
      path: '/:id(\\d+)',
      name: 'oversight-edit',
      component: () => import('@/views/oversight/OversightInstanceEdit.vue'),
    },
    ...withPrefix('/type', [
      {
        path: '',
        name: 'oversight-type',
        redirect: { name: 'oversight-type-list' },
      },
      {
        path: '/list',
        name: 'oversight-type-list',
        component: () => import('@/views/oversight/OversightTypeList.vue'),
      },
      {
        path: '/create',
        name: 'oversight-type-create',
        component: () => import('@/views/oversight/OversightTypeCreate.vue'),
      },
      {
        path: '/:id(\\d+)',
        name: 'oversight-type-edit',
        component: () => import('@/views/oversight/OversightTypeEdit.vue'),
      },
    ]),
  ]);
};
